import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollSalaryDetailDTO  {
    _originalTypeClassName = "zERP.BO.PayrollSalaryDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollSalaryDetailDTO.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.OvertimeHours = null;
this.PayrollSalaryDetailDTOKey = null;
this._key = this.PayrollSalaryDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Amount:any;
OvertimeHours:any;
SalaryDTO:any;
private _PayrollSalaryDetailDTOKey:any;
get PayrollSalaryDetailDTOKey(): any {
    return this._PayrollSalaryDetailDTOKey;
  }
set PayrollSalaryDetailDTOKey(value: any) {
    this._PayrollSalaryDetailDTOKey = value;
    this._key = value;
  }
static setSalaryDTO = ($this, value) => {
var oldValue = $this.SalaryDTO;
$this.SalaryDTO = value;
if (value != null) {
}
}

static Assign(psd: any): any{let psdDTO = new Domain.PayrollSalaryDetailDTO();
psdDTO.Id = psd?.Id;
psdDTO.Amount = psd?.Amount;
psdDTO.OvertimeHours = psd?.OvertimeHours;
Domain.PayrollSalaryDetailDTO.setSalaryDTO(psdDTO, Domain.SalaryRuleDTO.Assign(psd?.Salary));
return psdDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollSalaryDetailDTOKey == null || $this.PayrollSalaryDetailDTOKey == 0;
            }


}